import { useCallback } from 'react';

import InputSearch from '@cobliteam/ui/form/InputSearch';

export interface UserSearchProps {
  textFilter: string;
  setTextFilter: (newText: string) => void;
}

const UserSearch = ({ textFilter, setTextFilter }: UserSearchProps) => {
  const handleTextChange = useCallback(
    (value: string) => {
      setTextFilter(value);
    },
    [setTextFilter]
  );

  return <InputSearch placeholder='Procure por usuários' value={textFilter} debounceInMillis={500} autoFocus onChange={handleTextChange} className='w-full' />;
};

export default UserSearch;
